import { axiosObject } from "../config";

function getTeamMembers(team_uuid: any) {
  return new Promise((resolve, reject) => {
    let uri = `access/loco/resource/team-members/_read`;
    let payload = {
      apiConfig: {
        includeRelations: ["attributes", "user"],
      },
      limitBy: { per_page: 999, page: 1 },
      filterBy: [
        {
          attribute: "team_uuid",
          op: "eq",
          value: team_uuid,
        },
      ],
    };

    axiosObject
      .post(uri, payload)
      .then((response) => {
        resolve(response.data);
      })
      .catch((errors) => {
        reject(errors);
      });
  });
}

function getTeamMembersWithPagination(limitBy: any, team_uuid: any) {
  return new Promise((resolve, reject) => {
    let uri = `access/loco/resource/team-members/_read`;
    let payload = {
      apiConfig: {
        includeRelations: ["attributes", "user"],
      },
      limitBy: limitBy,
      filterBy: [
        {
          attribute: "team_uuid",
          op: "eq",
          value: team_uuid,
        },
      ],
    };

    axiosObject
      .post(uri, payload)
      .then((response) => {
        resolve(response.data);
      })
      .catch((errors) => {
        reject(errors);
      });
  });
}

function getNotificationsForBanker(payload: any) {
  return new Promise((resolve, reject) => {
    let uri = `auction/banker-notifications`;
    // let payload = { branch_uuid, status, type, approver_uuid };

    axiosObject
      .post(uri, payload)
      .then((response) => {
        resolve(response.data.data);
      })
      .catch((errors) => {
        reject(errors);
      });
  });
}

function verifyApprovalRequest(payload: any) {
  return new Promise((resolve, reject) => {
    let uri = `auction/approval-requests/verify`;

    axiosObject
      .post(uri, payload)
      .then((response) => {
        resolve(response.data);
      })
      .catch((errors) => {
        reject(errors);
      });
  });
}
function approveApprovalRequest(payload: any) {
  return new Promise((resolve, reject) => {
    let uri = `auction/approval-requests/approve`;

    axiosObject
      .post(uri, payload)
      .then((response) => {
        resolve(response.data);
      })
      .catch((errors) => {
        reject(errors);
      });
  });
}

function rejectApprovalRequest(payload: any) {
  return new Promise((resolve, reject) => {
    let uri = `auction/approval-requests/reject`;

    axiosObject
      .post(uri, payload)
      .then((response) => {
        resolve(response.data);
      })
      .catch((errors) => {
        reject(errors);
      });
  });
}

export {
  getTeamMembers,
  getTeamMembersWithPagination,
  getNotificationsForBanker,
  verifyApprovalRequest,
  approveApprovalRequest,
  rejectApprovalRequest,
};
